import {FormErrors} from 'yougile-util'
import {useGlobalKeyDown} from '@containers/hooks'
import {
  ChangeEmailFormFields as FormFields,
  useProfileStore
} from '../profile-store'

export const useFormPopup = (): {
  formData: FormFields
  formErrors: FormErrors<FormFields>
  isWait: boolean
  close: () => void
  submit: () => Promise<void>
  updateForm: (data: Partial<FormFields>) => void
} => {
  const [state, store] = useProfileStore()

  const {data: formData, errors: formErrors} = state.changeEmailForm
  const isWait = state.changeEmailWait
  const close = store.closeChangeEmailPopup
  const submit = store.submitChangeEmailForm
  const updateForm = store.updateChangeEmailForm

  useGlobalKeyDown({escape: close})

  return {formData, formErrors, isWait, close, submit, updateForm}
}
